import { render } from "./PasswordReset.vue?vue&type=template&id=48bf8236"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/PasswordReset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48bf8236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48bf8236', __exports__)) {
    console.log('reload')
    api.reload('48bf8236', __exports__)
  }
  
  module.hot.accept("./PasswordReset.vue?vue&type=template&id=48bf8236", () => {
    console.log('re-render')
    api.rerender('48bf8236', render)
  })

}


export default __exports__